var _effectorFileName = "/builds/gmini/front-utils/src/predicates.ts";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.every.js";
export var isString = function isString(value) {
  return typeof value == 'string';
};
export var isNumber = function isNumber(value) {
  return typeof value == 'number';
};
export var isNull = function isNull(value) {
  return value === null;
};
export var isUndefined = function isUndefined(value) {
  return typeof value == 'undefined';
};
export var isEmpty = function isEmpty(value) {
  return value == null;
};
export var isNotEmpty = function isNotEmpty(value) {
  return value != null;
};
export var isTruthy = function isTruthy(value) {
  return !!value;
};
export var or = function or() {
  for (var _len = arguments.length, predicates = new Array(_len), _key = 0; _key < _len; _key++) {
    predicates[_key] = arguments[_key];
  }

  return function (value) {
    return predicates.some(function (predicate) {
      return predicate(value);
    });
  };
};
export var and = function and() {
  for (var _len2 = arguments.length, predicates = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    predicates[_key2] = arguments[_key2];
  }

  return function (value) {
    return predicates.every(function (predicate) {
      return predicate(value);
    });
  };
};